import { render } from "./detectVideo.vue?vue&type=template&id=a2a6b5f6&scoped=true"
import script from "./detectVideo.vue?vue&type=script&lang=js"
export * from "./detectVideo.vue?vue&type=script&lang=js"

import "./detectVideo.vue?vue&type=style&index=0&id=a2a6b5f6&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a6b5f6"]])

export default __exports__